<footer id="appFooter" class="e11-bg-skin-app-bg-dark">
    <app-logo-color [height]="'40px'" [resizable]="false"></app-logo-color>
</footer>